import { makeStyles } from "tss-react/mui";

const useFabStyles = makeStyles()((theme) => ({
  fab: {
    position: "absolute",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    backgroundColor: theme.palette.grey.A100,
  },

  fabMenu: {
    position: "static",
    backgroundColor: "#00b373",
    borderRadius: "50%",
    width: 36,
    height: 36,
    minHeight: 36,
    "&.Mui-disabled": { backgroundColor: "#00b373", opacity: 1 },
  },

  fabMenuCount: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
  },

  icon: {
    color: theme.palette.grey.A700,
  },
}));

export default useFabStyles;
